module.exports = __webpack_public_path__ + "img/accountZhM.b7b45939.jpg";